import { useNavigate } from '@tanstack/react-router';
import { FlaskConical } from 'lucide-react';
import { AgroPipeCard } from './AgroPipeCard';

// Tela "Bancos de Dados" — aberta ao clicar no pipe Bancos de Dados da seleção
// da Agronomia. Hoje lista só Insumos (ex-Catálogo de insumos).
export function BancosDeDadosView() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col bg-bg px-8 pb-8 pt-7">
      <h1 className="text-[18px] font-semibold leading-6 text-text">Bancos de Dados</h1>
      <span className="text-sm text-text-2">Selecione o banco de dados</span>

      <div className="flex flex-wrap gap-3.5 pt-6">
        <AgroPipeCard
          titulo="Insumos"
          icone={<FlaskConical size={14} strokeWidth={1.7} />}
          onClick={() => void navigate({ to: '/agronomia/insumos' })}
        />
      </div>
    </div>
  );
}
